// HeaderNav.js
import React, { useContext, useState, useRef, useEffect } from "react";
import "./HeaderNav.css";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../../contexts/CurrentUserContext";
import EmployeePhoto from "../../images/cat-photo.png";

const HeaderNav = ({ navItems, isCompact }) => {
  const location = useLocation();
  const { userData } = useContext(UserContext);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const submenuRefs = useRef({});

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSubmenuItemClick = () => {
    setOpenSubmenu(null);
    handleScrollToTop();
  };

  const openSubmenuOnHover = (index) => {
    setOpenSubmenu(index);
  };

  const closeSubmenuOnLeave = () => {
    setOpenSubmenu(null);
  };

  const toggleSubmenuOnClick = (index) => {
    setOpenSubmenu((prevIndex) => (prevIndex === index ? null : index));
  };

  // Закрываем выпадающее меню при уходе мыши за пределы элемента навигации
  // Благодаря hover эффекту, это обрабатывается автоматически через onMouseLeave

  // Закрываем выпадающее меню при изменении локации
  useEffect(() => {
    setOpenSubmenu(null);
  }, [location.pathname]);

  const isPathActive = (path, submenu) => {
    // Проверяем, является ли текущий путь активным для элемента навигации
    if (location.pathname === path) return true;

    // Проверяем, есть ли подменю и активен ли какой-либо элемент подменю
    if (submenu && Array.isArray(submenu)) {
      return submenu.some((subItem) => {
        const subPath = subItem.path;
        // Проверяем точное совпадение или начало пути
        return (
          location.pathname === subPath ||
          location.pathname.startsWith(subPath + "/")
        );
      });
    }

    return false;
  };

  return (
    <nav className="nav__body">
      {navItems.map((item, index) => {
        const hasSubmenu = item.submenu && item.submenu.length > 0;
        const isActive = isPathActive(item.path, item.submenu);

        return (
          <div
            key={index}
            className={`nav__item ${
              openSubmenu === index ? "nav__item--open" : ""
            }`}
            ref={(el) => (submenuRefs.current[index] = el)}
            onMouseLeave={() => {
              if (openSubmenu === index) {
                closeSubmenuOnLeave();
              }
            }}
          >
            {hasSubmenu ? (
              <>
                <Link
                  to={item.submenu[0].path}
                  className={`nav__link ${isActive && "active"} ${
                    item.path === "/account" ? "nav__link--with-avatar" : ""
                  } nav__link--with-dropdown`}
                  onMouseEnter={() => openSubmenuOnHover(index)}
                  onMouseLeave={!isCompact ? closeSubmenuOnLeave : undefined}
                  onClick={(e) => {
                    if (isCompact) {
                      if (openSubmenu !== index) {
                        e.preventDefault();
                        toggleSubmenuOnClick(index);
                        return;
                      }
                      handleScrollToTop();
                      return;
                    }
                    handleScrollToTop();
                  }}
                >
                  {item.path === "/account" && (
                    <img
                      src={userData?.image || EmployeePhoto}
                      alt="Аватар"
                      className="nav__avatar"
                    />
                  )}
                  {item.label}
                  <span
                    className={`nav__dropdown-arrow ${
                      openSubmenu === index ? "open" : ""
                    }`}
                  >
                    ▼
                  </span>
                </Link>
                {openSubmenu === index && (
                  <div
                    className="nav__submenu"
                    onMouseEnter={() => openSubmenuOnHover(index)}
                    onMouseLeave={!isCompact ? closeSubmenuOnLeave : undefined}
                  >
                    {item.submenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subItem.path}
                        className="nav__submenu-item"
                        onClick={handleSubmenuItemClick}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <Link
                className={`nav__link ${
                  location.pathname === item.path && "active"
                } ${item.path === "/account" ? "nav__link--with-avatar" : ""}`}
                to={item.path}
                onClick={handleScrollToTop}
              >
                {item.path === "/account" && (
                  <img
                    src={userData?.image || EmployeePhoto}
                    alt="Аватар"
                    className="nav__avatar"
                  />
                )}
                {item.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default HeaderNav;
